import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const RadioSelectionContainer = styled(FlexRow)`
    padding: 12px;
    gap: 16px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};

    [data-automation-icon-name="arrow"] svg {
        width: 10px;
        height: 5px;
    }
`;

export const WithBorderBottom = styled(FlexRow)`
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
`;
